import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "../../context/TranslationsProvider";
import Header from "./components/Header";
import Footer from "./components/Footer";

const Success: React.FC = () => {
    const { lang } = useParams<{ lang: string }>();
    const { translate } = useTranslation();

    return (
        <div className="flex flex-col min-h-screen bg-[#f4f1ea]">
            <Header />
            <div className="flex-grow flex flex-col items-center p-4 md:p-10 mt-2 text-center">
                <div className="bg-white p-6 md:p-10 rounded-lg shadow-md max-w-lg w-full">
                    <h2 className="text-2xl font-bold mb-4 ">{translate("payment_success_message")}</h2>
                    <p className="text-lg text-gray-700 mb-6">{translate("payment_success_text")}</p>

                    <Link to={`/all-paintings`} className="px-6 py-3 bg-black text-orange-100 rounded-md text-lg">
                        {translate("continue_shopping")}
                    </Link>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Success;